import {GetLicenseRolesRoutine} from '../redux-routines';

export const initialState = {
  isFetching: false,
  data: {},
  error: null
};

export const licenseRolesReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetLicenseRolesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case GetLicenseRolesRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case GetLicenseRolesRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};
